export const VARIABLE_SELECTORS = {
  MIN_DATE: '{min_date}',
  MAX_DATE: '{max_date}',
};

export const DEFAULT_MESSAGES = {
  DESCRIPTION: `Arrives between ${VARIABLE_SELECTORS.MIN_DATE} - ${VARIABLE_SELECTORS.MAX_DATE}`,
  FALLBACK: 'Delivery date will be calculated at checkout',
};

export const TEST_MODE_EXAMPLE = 'https://storeName.myshopify.com/productName?testProductPromise=1';
